export function shuffle(list, random = Math.random) {
  const items = Array.isArray(list) ? list.slice() : []

  for (let i = items.length - 1; i > 0; i -= 1) {
    const j = Math.floor(random() * (i + 1))
    const swap = items[i]
    items[i] = items[j]
    items[j] = swap
  }

  return items
}

export function maybeShuffle(list, enabled, random) {
  return enabled ? shuffle(list, random) : (Array.isArray(list) ? list.slice() : [])
}
